import type { CountryCode } from 'libphonenumber-js'

const appendAsterisks = (s: string): string => {
  return `${s}${'*'.repeat(256)}`
}
export const PHONE_FORMAT_CHAR_ALLOWED: {
  [key: string]: any
} = {
  AU: [
    {
      mask: appendAsterisks('+61  ****  ***  ***'),
      startsWith: '0',
    },
    {
      mask: appendAsterisks('+61  ***  ***  ***'),
      startsWith: '',
    },
  ],
  CA: [
    {
      mask: appendAsterisks('+1  (***)  ***-****'),
      startsWith: '',
    },
  ],
  GB: [
    {
      mask: appendAsterisks('+44  *****  ***  ***'),
      startsWith: '0',
    },
    {
      mask: appendAsterisks('+44  ****  ***  ***'),
      startsWith: '',
    },
  ],
  NZ: [
    {
      mask: appendAsterisks('+64  ***  ***  *****'),
      startsWith: '0',
    },
    {
      mask: appendAsterisks('+64  ***  ***  ****'),
      startsWith: '',
    },
  ],
  US: [
    {
      mask: appendAsterisks('+1  (***)  ***-****'),
      startsWith: '',
    },
  ],
  ES: [
    {
      mask: appendAsterisks('+34 *** *** ***'),
      startsWith: '',
    },
  ],
  IT: [
    {
      mask: appendAsterisks('+39 {3}** *** ***[*]'),
      startsWith: '',
    },
  ],
  FR: [
    {
      mask: appendAsterisks('+33 * ** ** ** **'),
      startsWith: '',
    },
  ],
  GP: [
    {
      mask: appendAsterisks('+59\\0 {69\\0} ** ** **'),
      startsWith: '',
    },
  ],
  GF: [
    {
      mask: appendAsterisks('+594 {694} ** ** **'),
      startsWith: '',
    },
  ],
  MQ: [
    {
      mask: appendAsterisks('+596 {696} ** ** **'),
      startsWith: '',
    },
  ],
  RE: [
    {
      mask: appendAsterisks('+262 {692} ** ** **'),
      startsWith: '',
    },
  ],
  YT: [
    {
      mask: appendAsterisks('+262 {639} ** ** **'),
      startsWith: '',
    },
  ],
  PM: [
    {
      mask: appendAsterisks('+5\\08 {55} ** **'),
      startsWith: '',
    },
  ],
  NC: [
    {
      mask: appendAsterisks('+687 ** ** **'),
      startsWith: '',
    },
  ],
  PF: [
    {
      mask: appendAsterisks('+689 ** ** ** **'),
      startsWith: '',
    },
  ],
  WF: [
    {
      mask: appendAsterisks('+681 ** ** **'),
      startsWith: '',
    },
  ],
  DEFAULT: [
    {
      mask: appendAsterisks('*** *** *** *** ***'),
      startsWith: '',
    },
  ],
}

export const PHONE_FORMAT: {
  [key: string]: any
} = {
  AU: [
    {
      mask: '+61  0000  000  000',
      startsWith: '0',
    },
    {
      mask: '+61  000  000  000',
      startsWith: '',
    },
  ],
  CA: [
    {
      mask: '+1  (000)  000-0000',
      startsWith: '',
    },
  ],
  GB: [
    {
      mask: '+44  00000  000  000',
      startsWith: '0',
    },
    {
      mask: '+44  0000  000  000',
      startsWith: '',
    },
  ],
  NZ: [
    {
      mask: '+64  000  000  00000',
      startsWith: '0',
    },
    {
      mask: '+64  000  000  0000',
      startsWith: '',
    },
  ],
  US: [
    {
      mask: '+1  (000)  000-0000',
      startsWith: '',
    },
  ],
  ES: [
    {
      mask: '+34 000 000 000',
      startsWith: '6',
    },
    {
      mask: '+34 000 000 000',
      startsWith: '7',
    },
    {
      mask: '+34 000 000 000',
      startsWith: '',
    },
  ],
  IT: [
    {
      mask: '+39 {3}00 000 000[0]',
      startsWith: '',
    },
  ],
  FR: [
    {
      mask: '+33 0 00 00 00 00',
      startsWith: '6',
    },
    {
      mask: '+33 0 00 00 00 00',
      startsWith: '7',
    },
    {
      mask: '+33 0 00 00 00 00',
      startsWith: '',
    },
  ],
  GP: [
    {
      mask: '+59\\0 {69\\0} 00 00 00',
      startsWith: '',
    },
  ],
  GF: [
    {
      mask: '+594 {694} 00 00 00',
      startsWith: '',
    },
  ],
  MQ: [
    {
      mask: '+596 {696} 00 00 00',
      startsWith: '',
    },
  ],
  RE: [
    {
      mask: '+262 {692} 00 00 00',
      startsWith: '',
    },
  ],
  YT: [
    {
      mask: '+262 {639} 00 00 00',
      startsWith: '',
    },
  ],
  PM: [
    {
      mask: '+5\\08 {55} 00 00',
      startsWith: '',
    },
  ],
  NC: [
    {
      mask: '+687 00 00 00',
      startsWith: '',
    },
  ],
  PF: [
    {
      mask: '+689 00 00 00 00',
      startsWith: '',
    },
  ],
  WF: [
    {
      mask: '+681 00 00 00',
      startsWith: '',
    },
  ],
  DEFAULT: [
    {
      mask: '000 000 000 000 000',
      startsWith: '',
    },
  ],
} as const

export const LEADING_ZERO_FORMAT: {
  [key: string]: boolean
} = {
  AU: true,
  CA: false,
  GB: true,
  NZ: true,
  US: false,
  ES: false,
  IT: false,
  FR: false,
  GP: false,
  GF: false,
  MQ: false,
  RE: false,
  YT: false,
  PM: false,
  NC: false,
  PF: false,
  WF: false,
} as const

const AREA_CODES: {
  [key: string]: readonly number[]
} = {
  CA: [
    204, 226, 236, 249, 250, 289, 306, 343, 354, 365, 367, 368, 403, 416, 418, 428, 431, 437, 438, 450, 506, 514, 519, 548, 579, 581, 587, 604, 613, 639, 647,
    672, 705, 709, 778, 780, 782, 807, 819, 825, 867, 873, 879, 902, 905,
  ],
  US: [
    201, 202, 203, 205, 206, 207, 208, 209, 210, 212, 213, 214, 215, 216, 217, 218, 219, 220, 223, 224, 225, 228, 229, 231, 234, 239, 240, 248, 251, 252, 253,
    254, 256, 260, 262, 267, 269, 270, 272, 276, 279, 281, 301, 302, 303, 304, 305, 307, 308, 309, 310, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 323,
    325, 326, 330, 331, 332, 334, 336, 337, 339, 340, 341, 346, 347, 351, 352, 360, 361, 364, 380, 385, 386, 401, 402, 404, 405, 406, 407, 408, 409, 410, 412,
    413, 414, 415, 417, 419, 423, 424, 425, 430, 432, 434, 435, 440, 442, 443, 445, 447, 448, 458, 463, 464, 469, 470, 475, 478, 479, 480, 484, 501, 502, 503,
    504, 505, 507, 508, 509, 510, 512, 513, 515, 516, 517, 518, 520, 530, 531, 534, 539, 540, 541, 551, 559, 561, 562, 563, 564, 567, 570, 571, 572, 573, 574,
    575, 580, 582, 585, 586, 601, 602, 603, 605, 606, 607, 608, 609, 610, 612, 614, 615, 616, 617, 618, 619, 620, 623, 626, 628, 629, 630, 631, 636, 640, 641,
    646, 650, 651, 656, 657, 659, 660, 661, 662, 667, 669, 670, 671, 678, 680, 681, 682, 684, 689, 701, 702, 703, 704, 706, 707, 708, 710, 712, 713, 714, 715,
    716, 717, 718, 719, 720, 724, 725, 726, 727, 728, 731, 732, 734, 737, 740, 743, 747, 754, 757, 760, 762, 763, 765, 769, 770, 771, 772, 773, 774, 775, 779,
    781, 785, 786, 787, 801, 802, 803, 804, 805, 806, 808, 810, 812, 813, 814, 815, 816, 817, 818, 820, 826, 828, 830, 831, 832, 838, 839, 840, 843, 845, 847,
    848, 850, 854, 856, 857, 858, 859, 860, 862, 863, 864, 865, 870, 872, 878, 901, 903, 904, 906, 907, 908, 909, 910, 912, 913, 914, 915, 916, 917, 918, 919,
    920, 925, 928, 929, 930, 931, 934, 936, 937, 938, 939, 940, 941, 943, 945, 947, 948, 949, 951, 952, 954, 956, 959, 970, 971, 972, 973, 978, 979, 980, 983,
    984, 985, 986, 989,
  ],
} as const

export const AREA_CODES_REGEX: {
  [key: string]: string
} = {
  CA: `^1?\\(?(${AREA_CODES.CA.join('|')})\\)?`,
  US: `^1?\\(?(${AREA_CODES.US.join('|')})\\)?`,
  DEFAULT: '',
} as const

export const BLACKLISTED_NUMBERS: {
  [key: string]: RegExp | readonly string[]
} = {
  AU: ['400000000', '0400000000'],
  CA: [],
  GB: /^0?7(0{1,9}|6|418 ?4|452 ?[0-6]|457 ?6|509|700 ?(3|[7-9])|781|797|829|839 ?([1-2]|[7-8])|911 ?([0-1]|7)|924|937).*$/,
  NZ: ['20000000', '020000000', '200000000', '0200000000', '2000000000', '02000000000'],
  US: [],
} as const

export interface AllowCountriesConfig {
  countryCode: CountryCode
  name: string
}

export const DEFAULT_CONFIG: AllowCountriesConfig[] = [
  {
    countryCode: 'AU',
    name: 'Australia',
  },
  {
    countryCode: 'NZ',
    name: 'New Zealand',
  },
  {
    countryCode: 'US',
    name: 'United States',
  },
  {
    countryCode: 'GB',
    name: 'United Kingdom',
  },
  {
    countryCode: 'CA',
    name: 'Canada',
  },
  {
    countryCode: 'ES',
    name: 'Spain',
  },
  {
    countryCode: 'IT',
    name: 'Italy',
  },
  {
    countryCode: 'FR',
    name: 'France',
  },
]
